var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareCostIcon = function SvgCompareCostIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.546 4.8h1.151v1.122a5.25 5.25 0 0 1 2.493.86l-.653 1.045c-.546-.35-1.17-.6-1.84-.683v2.28c1.348.19 2.582.76 2.553 2.184-.024 1.383-1.134 2.202-2.547 2.398v1.193H9.552v-1.17c-1.01-.082-2.09-.439-2.802-1.032l.694-1.027c.475.404 1.283.742 2.102.837v-2.273l-.107-.018c-1.282-.184-2.452-.76-2.428-2.214.018-1.348 1.104-2.179 2.535-2.363zm2.404 6.873c.006-.498-.457-.79-1.253-.967v2.071c.736-.136 1.24-.516 1.253-1.104M8.323 8.266c-.006.54.404.82 1.223.986V7.168c-.742.137-1.211.534-1.223 1.098"
  })));
};
export default SvgCompareCostIcon;